import {
  QuestionCircleOutlined,
} from "@ant-design/icons";
import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  InputNumber,
  Popover,
  Radio,
  Row,
} from "antd";

import {
  Title,
  SubText,
  ContentContainer,
  MyCaseSection,
  Container,
  CaseDetailWrapper,
} from "../../../Form.style";

import { useEffect } from "react";

const Step2 = ({ data, setData, onPrev, onNext, itemLayout }) => {
  const [form] = Form.useForm();

  const onFinish = (values) => {
    setData(values);
    onNext();
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Container style={{ textAlign: "left" }}>
      <MyCaseSection>
        <ContentContainer>
          <Title>명도 사유 및 상황</Title>

          <div style={{ marginTop: 10 }}>
            <SubText style={{ textAlign: "left" }} type="secondary">
              명도소송의 사유와 현재 상황을 작성해주세요.
            </SubText>
          </div>

          <Divider style={{ marginTop: 10 }} />
          <CaseDetailWrapper>
            <Form
              {...itemLayout.form}
              layout="horizontal"
              onFinish={onFinish}
              initialValues={data}
              form={form}
              style={{
                marginTop: 10,
                marginBottom: 20,
                width: "100%",
                textAlign: "left",
              }}
              requiredMark={false}
            >
              <Form.Item
                label="명도소송 사유"
                name={["vacatehouse", "reason"]}
                rules={[
                  {
                    required: true,
                    message: "명도소송 사유를 선택해주세요",
                  },
                ]}
              >
                <Checkbox.Group style={{ width: "100%" }}>
                  <Row>
                    <Col span={12}>
                      <Checkbox value="overdue_rent">
                        차임 연체 (3기 이상)
                      </Checkbox>
                    </Col>
                    <Col span={12}>
                      <Checkbox value="expired_stay">
                        계약 만료 후 미퇴거
                      </Checkbox>
                    </Col>
                    <Col span={12}>
                      <Checkbox value="illegal_sublease">
                        무단 전대(전전세)
                      </Checkbox>
                    </Col>
                    <Col span={12}>
                      <Checkbox value="misuse">
                        용도 위반 사용
                      </Checkbox>
                    </Col>
                    <Col span={12}>
                      <Checkbox value="demolition">
                        건물 철거/재건축
                      </Checkbox>
                    </Col>
                    <Col span={12}>
                      <Checkbox value="etc">기타</Checkbox>
                    </Col>
                  </Row>
                </Checkbox.Group>
              </Form.Item>

              <Form.Item
                noStyle
                shouldUpdate={(prevValues, currentValues) => {
                  return (
                    JSON.stringify(prevValues.vacatehouse?.reason) !==
                    JSON.stringify(currentValues.vacatehouse?.reason)
                  );
                }}
              >
                {() => {
                  const reasons = form.getFieldValue(["vacatehouse", "reason"]) || [];
                  return (
                    <>
                      {reasons.includes("etc") && (
                        <Form.Item
                          label="기타 사유"
                          name={["vacatehouse", "reasonEtc"]}
                          rules={[
                            {
                              required: true,
                              message: "기타 사유를 입력해주세요",
                            },
                          ]}
                        >
                          <Input placeholder="기타 사유를 입력하세요" />
                        </Form.Item>
                      )}
                      {reasons.includes("overdue_rent") && (
                        <Form.Item
                          label={
                            <>
                              연체 차임 총액
                              <Popover
                                content={
                                  <div>
                                    현재까지 연체된 차임(월세)의
                                    <br />
                                    총 합계 금액을 입력해주세요.
                                  </div>
                                }
                                placement="bottom"
                                trigger="click"
                              >
                                <QuestionCircleOutlined style={{ marginLeft: 5 }} />
                              </Popover>
                            </>
                          }
                          name={["vacatehouse", "overdueAmount"]}
                          rules={[
                            {
                              required: true,
                              message: "연체 차임 총액을 입력해주세요",
                            },
                          ]}
                        >
                          <InputNumber
                            formatter={(value) =>
                              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            }
                            addonBefore="금"
                            addonAfter="원"
                            controls={false}
                          />
                        </Form.Item>
                      )}
                    </>
                  );
                }}
              </Form.Item>

              <Form.Item
                label="내용증명 발송 여부"
                name={["vacatehouse", "certification"]}
                rules={[{ required: true, message: "" }]}
              >
                <Radio.Group>
                  <Radio.Button value="y">예</Radio.Button>
                  <Radio.Button value="n">아니오</Radio.Button>
                </Radio.Group>
              </Form.Item>

              <Form.Item
                noStyle
                shouldUpdate={(prevValues, currentValues) => {
                  return (
                    prevValues.vacatehouse?.certification !==
                    currentValues.vacatehouse?.certification
                  );
                }}
              >
                {() =>
                  form.getFieldValue(["vacatehouse", "certification"]) === "y" ? (
                    <Form.Item
                      label="내용증명 발송일"
                      name={["vacatehouse", "certificationDate"]}
                      rules={[
                        {
                          required: true,
                          message: "발송일을 선택해주세요",
                        },
                      ]}
                    >
                      <DatePicker
                        style={{ width: "100%" }}
                        placeholder="날짜를 선택하세요"
                      />
                    </Form.Item>
                  ) : null
                }
              </Form.Item>

              <Form.Item
                label={
                  <>
                    계약 해지 통보 여부
                    <Popover
                      content={
                        <div>
                          임차인에게 계약 해지를 통보한 적이 있는지
                          <br />
                          선택해주세요. (문자, 카톡, 내용증명 등)
                        </div>
                      }
                      placement="bottom"
                      trigger="click"
                    >
                      <QuestionCircleOutlined style={{ marginLeft: 5 }} />
                    </Popover>
                  </>
                }
                name={["vacatehouse", "terminationNotice"]}
                rules={[{ required: true, message: "" }]}
              >
                <Radio.Group>
                  <Radio.Button value="y">예</Radio.Button>
                  <Radio.Button value="n">아니오</Radio.Button>
                </Radio.Group>
              </Form.Item>

              <Row justify="space-between">
                <Col span={6}>
                  <Button
                    type="primary"
                    onClick={onPrev}
                    style={{ width: "100%", maxWidth: "100px" }}
                  >
                    이전
                  </Button>
                </Col>
                <Col span={6} offset={10} style={{ textAlign: "right" }}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{ width: "100%", maxWidth: "100px" }}
                  >
                    다음
                  </Button>
                </Col>
              </Row>
            </Form>
          </CaseDetailWrapper>
        </ContentContainer>
      </MyCaseSection>
    </Container>
  );
};

export default Step2;
